import Section from "@/components/ui/section";
import Image from "next/image";
import React from "react";

export default function Banner() {
  return (
    <div className="w-full">
      <div className="relative w-full lg:h-[30vw] md:h-[454px] h-[300px]">
        <Image
          src="/images/team-banner@3x.webp"
          alt="team Banner"
          fill
          className="object-cover object-center"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1920px"
        />
        <div className="absolute w-full h-full top-0 left-0 bg-black/10" />
      </div>
      <div className="border-b-[0.5px] border-darkGrey/50 w-full pt-10 px-4 md:px-8 flex flex-col lg:gap-0 gap-20">
        <div className="lg:max-w-[500px] w-full flex flex-col">
          {/* Text Content */}
          <h1 className="md:text-2xl text-xl text-darkGrey/80 mb-4 max-w-[577px] w-full font-havletica font-light">
            Coming Together Is A Beginning, Staying Together Is Progress, And
            Working Together Is Success
          </h1>
          <p className="text-darkgrey/70 text-sm w-full text-right ml-auto font-light">
            ~ Henry Ford
          </p>
        </div>
        <div className="flex md:flex-row md:items-end w-full md:justify-between flex-col gap-12 lg:gap-0 lg:pr-[100px] ">
          <p className="text-[#292929]/70 font-havletica text-lg pb-4">
            Meet The Chalksters
          </p>
          <div className="flex flex-row items-end">
            {/* Name and Title */}
            <div className="lg:text-right pb-4">
              <p className="text-[#333333]/80 text-2xl font-light font-havletica">
                Coco
              </p>
              <p className="text-[#333333]/80 font-light text-sm">
                CCO - Chief Cuddly Officer
              </p>
            </div>
            {/* Image of Coco */}
            <div className="relative lg:w-[180px] lg:h-[213px] md:w-[120px] md:h-[120px] w-[150px] h-[160px] md:ml-4">
              <Image
                src="/images/coco@3x.webp"
                alt="Coco"
                fill
                className="object-contain"
                sizes="479px"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Priyanka */}
      <div className="pb-12 flex flex-col md:flex-row lg:gap-12 md:gap-6 gap-4 mt-12 bg-[#F6F5F1] lg:max-w-[1132px] mx-auto lg:px-0 md:px-8 px-4">
        <div className="w-full 2xl:h-[25vw] 2xl:w-[40vw] lg:w-[524px] md:w-[350px] lg:h-[394px] h-[250px] flex justify-center items-center relative">
          <Image
            src="/images/priyanka-team@3x.webp"
            alt="priyanka"
            fill
            sizes="500px"
            className="w-full h-auto object-cover object-center"
          />
        </div>
        <div className="flex flex-col justify-center lg:gap-5 gap-4 w-full lg:w-1/2 lg:p-6 lg:pr-10">
          <p className="lg:text-lg text-base text-darkGrey/70 font-havletica !leading-tight">
           Our interior designing firm is dedicated to crafting bespoke and creative solutions that harmonize functionality with aesthetic appeal.
          </p>
          <p className="text-sm text-darkGrey/70 font-light !leading-tight">
            As interior designers, we transform spaces into captivating
            environments that reflect your unique style. Our interior designing
            firm is dedicated to crafting bespoke solutions that harmonize
            functionality with aesthetic appeal. As interior designers, we
            transform spaces into captivating environments that reflect your
            unique style. Our interior designing firm is dedicated to crafting
            bespoke solutions Coming Together Is A Beginning, Staying Together Is Progress, And Working Together Is Success.
          </p>
          <div className="flex flex-col gap-1 lg:mt-6 md:mt-2 mt-6">
            <p className="lg:text-lg text-base text-darkGrey/70 font-havletica">
              Priyanka Singh
            </p>
            <p className="text-[#333333]/80 font-light text-sm font-havletica">
              Founder &amp; Studio Head
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
